import {
  Box,
  Divider,
  Grid,
  GridColumn,
  Text,
  useTheme
} from "@modernatx-internal/component-library";
import React from "react";

import { ContentComponentProps, FooterContent } from "@/content-V2/types";

export const Footer: React.FC<ContentComponentProps<FooterContent>> = ({
  links,
  label,
  veevaCode
}) => {
  const year = React.useMemo(() => new Date().getFullYear(), []);
  const { mode } = useTheme();
  const isDark = mode === "dark";

  const renderLinks = React.useCallback(() => {
    if (!links) {
      return null;
    }

    return links.map((link, index) => (
      <React.Fragment key={index}>
        <Text
          variant="body-2-regular"
          sx={{
            display: "flex",
            gap: 6,
            "& a, & button, & a *, & button *": {
              color: "text-secondary"
            },
            "& a:hover, & button:hover": {
              color: "text-secondary"
            }
          }}
        >
          {link}
        </Text>
        {index < links.length - 1 && (
          <Divider
            direction="vertical"
            color="stroke-neutral-tertiary"
            thickness="sm"
            sx={{
              display: ["none", null, "block"]
            }}
          />
        )}
      </React.Fragment>
    ));
  }, [links]);

  return (
    <Box
      as="footer"
      sx={{
        backgroundColor: isDark ? "surface-brand" : "surface-neutral",
        color: isDark ? "text-default" : "text-secondary",
        py: 8
      }}
    >
      <Grid variant="uniform-12">
        <GridColumn>
          <Box
            sx={{
              display: "flex",
              flexDirection: ["column", null, "row"],
              gap: [4, null, 0]
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: ["column", null, "row"],
                gap: [3, null, 6]
              }}
            >
              {links && renderLinks()}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: ["wrap", null, "nowrap"],
                gap: 6,
                marginInlineStart: [0, null, "auto"]
              }}
            >
              {label && (
                <Text
                  variant="body-2-regular"
                  sx={{ display: "flex", flexDirection: "row", gap: 6 }}
                >
                  {label}
                  <Divider direction="vertical" color="stroke-neutral-tertiary" thickness="sm" />
                </Text>
              )}
              <Text variant="body-2-regular">© {year}</Text>
              {!!veevaCode && (
                <Text variant="body-2-regular" sx={{ marginInlineStart: [0, null, -4] }}>
                  {veevaCode}
                </Text>
              )}
            </Box>
          </Box>
        </GridColumn>
      </Grid>
    </Box>
  );
};
